"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimePicker = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const time_picker_1 = tslib_1.__importDefault(require("antd/es/time-picker"));
exports.TimePicker = (_a) => {
    var { className = '', popupClassName = '' } = _a, rest = tslib_1.__rest(_a, ["className", "popupClassName"]);
    return (React.createElement(time_picker_1.default, Object.assign({ className: `clp-timepicker ${className}`, popupClassName: `clp-timepicker-popup ${popupClassName}` }, rest)));
};
//# sourceMappingURL=TimePicker.js.map